import { transformAmount } from "@circle-react/components/Paywalls/Admin/PaywallsAdmin/FormModal/helpers/paywallCustomizationSerializer";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";

import { t } from "@/i18n-js/instance";

import { defaultFormatPaywallCurrency } from "../constants";
import type { PriceScenariosProps } from "../types";
import { usePriceProviderContext } from "./PriceProvider";

const getCouponApplicationAttributes = ({
  paywall,
  price,
  couponApplication,
}: PriceScenariosProps) => {
  if (!price.upfront_payment_amount || !couponApplication) {
    return null;
  }

  return {
    title: formatPaywallCurrencyAmount(
      paywall.currency,
      Math.max(
        price.upfront_payment_amount -
          (couponApplication?.discount_amount || 0),
        0,
      ),
      defaultFormatPaywallCurrency,
    ),
    oldTitle: formatPaywallCurrencyAmount(
      paywall.currency,
      price.upfront_payment_amount,
      defaultFormatPaywallCurrency,
    ),
    suffix: t("intro_fee").toLowerCase(),
  };
};

const getReducedPriceAttributes = ({
  paywall,
  price,
  reducedPrice,
}: PriceScenariosProps) => {
  if (!price.upfront_payment_amount || !reducedPrice) {
    return null;
  }

  const transformedAmount = transformAmount(reducedPrice.upfront_amount);
  if (transformedAmount <= price.upfront_payment_amount) {
    return null;
  }

  return {
    title: formatPaywallCurrencyAmount(
      paywall.currency,
      price.upfront_payment_amount,
      defaultFormatPaywallCurrency,
    ),
    oldTitle: formatPaywallCurrencyAmount(
      paywall.currency,
      transformAmount(reducedPrice.upfront_amount),
      defaultFormatPaywallCurrency,
    ),
    suffix: t("intro_fee").toLowerCase(),
  };
};

const getDefaultPriceAttributes = ({ paywall, price }: PriceScenariosProps) => {
  if (!price.upfront_payment_amount) {
    return null;
  }

  return {
    title: formatPaywallCurrencyAmount(
      paywall.currency,
      price.upfront_payment_amount,
      defaultFormatPaywallCurrency,
    ),
    oldTitle: undefined,
    suffix: t("intro_fee").toLowerCase(),
  };
};

export const IntroFee = (props: PriceScenariosProps) => {
  const { Title } = usePriceProviderContext();

  const titleProps =
    getCouponApplicationAttributes(props) ||
    getReducedPriceAttributes(props) ||
    getDefaultPriceAttributes(props);

  if (!titleProps) {
    return null;
  }

  return <Title {...titleProps} />;
};
